import { render } from "./SearchTermsForm.vue?vue&type=template&id=57b61dba"
import script from "./SearchTermsForm.vue?vue&type=script&lang=js"
export * from "./SearchTermsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__